<template>
    <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
            <v-card-title class="accent white--text subheading">
                Login
            </v-card-title>
            <v-card-text>
                <v-text-field
                        v-model="username"
                        label="User"
                >
                </v-text-field>
                <v-text-field
                    v-model="password"
                    type="password"
                    label="Password"
                    @keyup.enter="loginProcess"
                ></v-text-field>
                <v-card-actions>
                   {{message}} <v-btn block class="primary" @click="loginProcess">Login</v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small flat @click="urlDialog=true" class="grey--text">Set Server URL</v-btn>
                    <set-u-r-l v-model="urlDialog"></set-u-r-l>
                </v-card-actions>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {login, jwtDecode} from '../../helper'
    import SetURL from './setURL'

  export default {
    name: 'LoginDialog',
    components: { SetURL },
    props:{
    },
    data () {
      return {
        dialog: false,
        password: '',
        username: '',
        message: '',
        urlDialog: false
      }
    },
    watch: {

    },
    mounted () {
      this.dialog =true
      let token = localStorage.getItem('pass')
      if (!token) {
        this.dialog = true
      }
    },
    methods: {
      async loginProcess () {
        this.message = 'Login in Progress.'
          let res = await login(this.username, this.password)
          if (res.result=='OK') {
            this.$store.dispatch('setUser', {token: res.token, content: jwtDecode(res.token)})
            localStorage.setItem('pass', res.token)
              if(this.$route.params.wantedRoute){
                  window.location.href=this.$route.params.wantedRoute;
              } else {
                  window.location.href="/";
              }

          } else{
            this.message = 'Login Failed.  Please try again.'
          }
      }
    }
  }
</script>

<style scoped>

</style>
